import {useMapContext} from '../../../context'
import type {MapRef} from '../../../model'

export const useMapRef = (): MapRef | undefined => {
  const mapContext = useMapContext()
  if (!mapContext.mapRef) {
    return
  }
  return mapContext.mapRef
}
